<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>重要提醒</el-breadcrumb-item>
        <el-breadcrumb-item>员工首页</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_work1.jpg">
            <p class="user">我的今日任务</p>
            <p class="number">{{NumDay}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_work2.jpg">
            <p class="user">我的本周任务</p>
            <p class="number">{{NumWeek}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_work3.jpg">
            <p class="user">我的本月任务</p>
            <p class="number">{{NumMonth}}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_war1.jpg">
            <p class="user">我的7日内逾期任务</p>
            <p class="numberyellow">{{NumDelay7}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_war2.jpg">
            <p class="user">我的3日内逾期任务</p>
            <p class="numberyellow">{{NumDelay3}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <img class="topimg" src="../../assets/images/flat_war3.jpg">
            <p class="user">我的已逾期任务</p>
            <p class="numberred">{{NumDelay0}}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">公告</div>
          <!-- 数据列表 start -->
          <el-table :data="dataList1" border stripe height="280px">
            <el-table-column prop="Createtime" label="创建时间" min-width="25%"></el-table-column>
            <el-table-column prop="Filename" label="标题" min-width="55%"></el-table-column>
            <el-table-column prop="" label="文件" min-width="20%">
              <template v-slot="scope">
                <el-link  size="mini" style="margin-left: 0; margin-right: 5px" :href="scope.row.Fileinfo" target="_blank">查看文件</el-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 数据列表 end -->
          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange1"
              :page-size="10"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum1">
            </el-pagination>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">消息</div>
          <!-- 数据列表 start -->
          <el-table :data="dataList2" border stripe height="280px">
            <el-table-column prop="Createtime" label="创建时间" min-width="25%"></el-table-column>
            <el-table-column prop="Title" label="标题" min-width="15%"></el-table-column>
            <el-table-column prop="Message" label="消息" min-width="60%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
          <!-- 分页 -->
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentPageChange2"
              :page-size="5"
              layout="total, prev, pager, next, jumper"
              :total="dataListnum2">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 弹出框 -->
    <el-dialog title="未读消息(请到消息中心查看详情)" :visible.sync="displaydialog" width="30%" :close-on-click-modal="false">
      <el-form :model="messageForm" ref="messageFormRef" label-width="70px">
        <el-form-item label="" class="addAdminForm">
          <p v-for="item in messagelist"> 标题： {{item.Title}}</p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 end -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyHomeForEmployees',
  data () {
    return {
      NumDay: 0,
      NumWeek: 0,
      NumMonth: 0,
      NumDelay7: 0,
      NumDelay3: 0,
      NumDelay0: 0,
      dataList1: [],
      dataListnum1: 0,
      selectedPageNo1: 1,
      dataList2: [],
      dataListnum2: 0,
      selectedPageNo2: 1,
      displaydialog: false,
      messageForm: {},
      messagelist: []
    }
  },
  mounted () {
    this.apiGetWorkbenchsingleList()

    this.apiGetErp3FileNum40()
    this.apiGetErp3FileList40()

    this.apiGetMessageCenterAllNum()
    this.apiGetMessageCenterAllList()

    this.apiGetMessageCenterUnreadList()
  },
  methods: {
    handleCurrentPageChange1 (selectedPageNo) {
      this.selectedPageNo1 = selectedPageNo
      this.apiGetErp3FileList40()
    },
    handleCurrentPageChange2 (selectedPageNo) {
      this.selectedPageNo2 = selectedPageNo
      this.apiGetMessageCenterAllList()
    },
    apiGetMessageCenterAllNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterAllNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum2 = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMessageCenterAllList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo2
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterAllList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList2 = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkbenchsingleList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: 1,
        querytype: 0
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkbenchsingleList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.NumDay = response.data.NumDay
            that.NumWeek = response.data.NumWeek
            that.NumMonth = response.data.NumMonth
            that.NumDelay7 = response.data.NumDelay7
            that.NumDelay3 = response.data.NumDelay3
            that.NumDelay0 = response.data.NumDelay0
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp3FileNum40: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        filetype: 40,
        jigouid: '-1'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3FileNum40, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum1 = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp3FileList40: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo1,
        filetype: 40,
        jigouid: '-1'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp3FileList40, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList1 = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMessageCenterUnreadList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterUnreadList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.messagelist = response.data.List
            if (that.messagelist.length > 0) {
              that.displaydialog = true
            } else {
              that.displaydialog = false
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
      color:#999;
      width: 140px;
      margin: 0 10px 0 10px;
      font-size: 15px;
    }
    .number{
      color:#409eff;
      font-size: 30px;
      margin: 0;
      font-weight: bold;
    }
    .numberyellow{
      color:#e6a23c;
      font-size: 30px;
      margin: 0;
      font-weight: bold;
    }
    .numberred{
      color:#f56c6c;
      font-size: 30px;
      margin: 0;
      font-weight: bold;
    }
    .topimg{
      width: 64px;
      height: 64px;
    }
}
.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
